"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUiMousePosition = exports.moveCameraByOffset = exports.getCursorWorldPosition = exports.getCursorPhysicsPosition = exports.setCameraXY = exports.getCameraXY = exports.uiToWorld = exports.worldToPhysics = exports.physicsToWorld = exports.physicsToCamera = exports.tileToPhysics = exports.physicsTileSize = exports.tileSize = exports.update = void 0;
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var cOx = 0;
var cOy = 0;
var update = function (onUpdate) {
    // TODO: create generic camera
    voyageCamera_sidecar_1.voyageCamera.update(onUpdate);
};
exports.update = update;
exports.tileSize = 40;
exports.physicsTileSize = exports.tileSize / minigolfDefs_sidecar_1.minigolfDefs.physicsScale;
var tileToPhysics = function (tx, ty) {
    var physicsScale = minigolfDefs_sidecar_1.minigolfDefs.physicsScale;
    return {
        x: (tx * exports.tileSize) / physicsScale + cOx,
        y: (ty * exports.tileSize) / -physicsScale + cOy,
    };
};
exports.tileToPhysics = tileToPhysics;
var physicsToCamera = function (px, py) {
    var physicsScale = minigolfDefs_sidecar_1.minigolfDefs.physicsScale;
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: px * physicsScale + cOx,
        y: py * -physicsScale + cOy,
    };
};
exports.physicsToCamera = physicsToCamera;
var physicsToWorld = function (px, py) {
    var physicsScale = minigolfDefs_sidecar_1.minigolfDefs.physicsScale;
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: px * physicsScale - cam.cameraX + cOx,
        y: py * -physicsScale - cam.cameraY + cOy,
    };
};
exports.physicsToWorld = physicsToWorld;
var worldToPhysics = function (wx, wy) {
    var physicsScale = minigolfDefs_sidecar_1.minigolfDefs.physicsScale;
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: (wx - cOx + cam.cameraX) / physicsScale,
        y: (wy - cOy + cam.cameraY) / -physicsScale,
    };
};
exports.worldToPhysics = worldToPhysics;
var uiToWorld = function (ux, uy) {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return {
        x: ux + cam.cameraX + cOx,
        y: uy + cam.cameraY + cOy,
    };
};
exports.uiToWorld = uiToWorld;
var getCameraXY = function () {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    return { cx: cam.cameraX, cy: cam.cameraY };
};
exports.getCameraXY = getCameraXY;
var setCameraXY = function (cx, cy) {
    voyageCamera_sidecar_1.voyageCamera.setCameraXY(cx, cy);
};
exports.setCameraXY = setCameraXY;
var getCursorPhysicsPosition = function () {
    var cursor = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var physicsCursor = exports.worldToPhysics(cursor.mx, cursor.my);
    return physicsCursor;
};
exports.getCursorPhysicsPosition = getCursorPhysicsPosition;
var getCursorWorldPosition = function () {
    var cursor = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var physicsCursor = exports.uiToWorld(cursor.mx, cursor.my);
    return physicsCursor;
};
exports.getCursorWorldPosition = getCursorWorldPosition;
var moveCameraByOffset = function (x, y) {
    //let { physicsScale } = crokinoleDefs
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    //cam.cameraX += x //* physicsScale
    //cam.cameraY += y //* physicsScale
    voyageCamera_sidecar_1.voyageCamera.setCameraXY(cam.cameraX + x, cam.cameraY + y);
    //voyageCamera.constrainToBounds()
};
exports.moveCameraByOffset = moveCameraByOffset;
var getUiMousePosition = function () {
    return voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
};
exports.getUiMousePosition = getUiMousePosition;
